import { render, staticRenderFns } from "./StartDispatchIcon.vue?vue&type=template&id=c8fd3638"
import script from "./StartDispatchIcon.vue?vue&type=script&lang=js"
export * from "./StartDispatchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports